import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { DocConverterApiService } from '../api/doc-converter-api.service';
import { take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentService {
  constructor(private docConverterApiService: DocConverterApiService) {}

  download(
    html: string,
    name: string,
    printOptions: {
      margin: {
        top: string;
        bottom: string;
        left: string;
        right: string;
      };
      headerTemplate: string;
      footerTemplate: string;
      displayHeaderFooter: boolean;
      isHideBottomLineSignature?: boolean;
    } = {
      margin: {
        top: '120px',
        bottom: '120px',
        left: '50px',
        right: '50px',
      },
      headerTemplate: ' ',
      footerTemplate: ' ',
      displayHeaderFooter: false,
      isHideBottomLineSignature: false,
    },
    accessToken?: string,
  ) {
    const domParser = new DOMParser();
    const doc = domParser.parseFromString(html, 'text/html');
    const signatureBoxNodes = doc.querySelectorAll('.redr-signature-field:not(.confirmed)');
    const newSignature =
      '<div style="' +
      '    width: 220px;' +
      '    height: 80px;' +
      (!printOptions?.isHideBottomLineSignature ? '    border-bottom: 1px solid;' : ' ') +
      '    margin-bottom: 1em;' +
      '"></div>';
    signatureBoxNodes.forEach((signatureBoxNode: any) => {
      signatureBoxNode.parentElement.innerHTML = newSignature;
    });
    const inlineFieldNodes = doc.querySelectorAll('.redr-inline-field');
    inlineFieldNodes.forEach(inlineField => {
      const labelFake = inlineField.querySelector('.label-fake-mask');
      if (labelFake) {
        const span = document.createElement('span');
        span.style.display = 'inline-block';
        span.style.borderBottom = '1px solid';
        span.style.width = '100px';
        inlineField.replaceWith(span);
      }
    });
    // console.log(doc.documentElement.outerHTML);
    this.docConverterApiService
      .html2pdf({
        html: doc.documentElement.outerHTML,
        printOptions,
        accessToken,
      })
      .pipe(take(1))
      .subscribe(res => {
        saveAs(res, name + '.pdf');
      });
  }
}
